import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PermissionsService {


   private principalURL = environment.apiUrl

  constructor(private http: HttpClient) {}

  // Devuelve array de claves: ['case.view', 'case.signed.view', ...]
  getMyViewPermissions() {
    return this.http.get<string[]>(`${this.principalURL}/permissions/me`);
  }

  // Si prefieres mapa: { 'case.view': true, ... }
  getMyViewPermissionsMap() {
    return this.http.get<Record<string, boolean>>(
      `${this.principalURL}/permissions/me`,
      { params: { format: 'map' } }
    );
  }

  getPermissionsByEmployee(empleadoId: number) {
  // ajusta la URL si usas otra ruta
  return this.http.get<any>(
    `${this.principalURL}/permissions/employees/${empleadoId}`
  );
}

updateEmployeePermissions(empleadoId: number, payload: { add: number[], remove: number[] }) {
  return this.http.post<any>(`${this.principalURL}/permissions/employees/update/${empleadoId}`, payload);
}

}